// extracted by mini-css-extract-plugin
export default {"client":"User_client__5Ybwc","select":"User_select__a9j6v","minus":"User_minus__tpetz","icon":"User_icon__9qp7X","modal":"User_modal__164Ff","message":"User_message__edjTR"};